import React from 'react';

import { orderBy } from 'lodash';
import type { SelectOption } from 'interface/filterOptions';

import { Avatar } from '@vyaguta/vyaguta-ui';

import { extractFullName, getEmpImageUrl } from './string';

export const mapAndSortSelectOptions = (
  options: SelectOption[],
  columns: keyof SelectOption
): Array<{ label: string; value: string | number; empId?: string }> => {
  const sortedOptions = orderBy(options, [(option) => option[columns].toLowerCase()]);

  const mappedOptions = sortedOptions.map((option) => {
    if (option.empId) {
      return {
        label: option.name,
        value: option.id,
        empId: option.empId,
      };
    }

    return {
      label: option.name,
      value: option.id,
    };
  });

  return mappedOptions;
};

export const getOptionWithAvatar = (option: {
  label: string;
  value: string | number;
  empId?: string;
}): {
  label: React.ReactNode;
  value: string | number;
} => {
  return {
    label: (
      <div className="d-flex flex-row align-items-center employee__details">
        {option.empId && <Avatar image={getEmpImageUrl(option.empId || '', '')} alt={option.label} size="smaller" />}
        <span className="ml-2x">{option.label}</span>
      </div>
    ),
    value: option.value,
  };
};

export const mapOptionWithAvatar = (
  options: Array<{ label: string; value: string | number; empId?: string }>
): Array<{ label: React.ReactNode; value: string | number }> => {
  return options.map((option) => getOptionWithAvatar(option));
};

export const mapUser = (
  users: Array<{
    id: string | number;
    fullname?: string;
    firstName?: string;
    middleName?: string | null;
    lastName?: string;
    empId?: string;
  }>
): SelectOption[] => {
  return users.map((user) => ({
    id: user.id,
    name:
      user.fullname ||
      extractFullName(
        { firstName: user.firstName || '', middleName: user.middleName, lastName: user.lastName || '' },
        true
      ),
    empId: user.empId,
  }));
};

export const mapUsersWithAvatar = (
  users: Array<{
    id: string | number;
    fullname?: string;
    firstName?: string;
    middleName?: string | null;
    lastName?: string;
    empId?: string;
  }>
): Array<{ label: React.ReactNode; value: string | number }> => {
  return mapOptionWithAvatar(mapAndSortSelectOptions(mapUser(users), 'name'));
};
